import type { Middleware } from '@reduxjs/toolkit'
import config from 'src/config'
export type SavedList = { id: string; name: string; items: { id: number; key: string }[]; shareToken?: string }
export async function wishlistRequest(action: string, body: Record<string, unknown>) {
  const response = await fetch(`${config.api_server.online}/wishlists/${action}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, cache: 'no-store', body: JSON.stringify({ ...body, shopId: config.shop.shop }) })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Wunschliste momentan nicht erreichbar.')
  return data
}
export const wishlistAccountMiddleware: Middleware = api => {
  let generation = 0, credential: string | null = null, queue = Promise.resolve()
  const apply = (lists: SavedList[], selected?: string) => {
    const id = selected || api.getState().Wunschliste.activeList || 'default'
    api.dispatch({ type: 'wishlistAccountLoaded', payload: { lists, activeList: lists.some(list => list.id === id) ? id : 'default' } })
  }
  return next => action => {
    if (typeof window === 'undefined' || ![101, 202].includes(config.shop.shop)) return next(action)
    if (action.type === 'login' && action.payload.token !== credential) {
      credential = action.payload.token; const token = credential!, version = ++generation
      let guest: { items?: Record<string, { id: number; key: string }> } = {}
      try { guest = JSON.parse(localStorage.getItem('wunschliste') || '{}') } catch { /* Invalid browser data must not block account loading. */ }
      const result = next(action)
      api.dispatch({ type: 'wishlistAccountLoading' })
      queue = wishlistRequest('merge', { token, items: Object.values(guest.items || {}) }).then(data => {
        if (version !== generation) return
        localStorage.removeItem('wunschliste'); apply(data.lists)
      }).catch(error => { if (version === generation) api.dispatch({ type: 'wishlistAccountError', payload: error.message }) })
      return result
    }
    if (action.type === 'logout') {
      if (credential) { credential = null; generation++; api.dispatch({ type: 'wishlistAccountReset' }) } return next(action)
    }
    if (credential && action.type === 'restoreWunschlisteItems') return action
    const operation = action.type === 'addWunschlisteItem' ? { action: 'add', item: action.payload }
      : action.type === 'removeWunschlisteItem' ? { action: 'remove', key: action.payload }
      : action.type === 'wishlistCommand' ? action.payload : null
    if (credential && operation) {
      const token = credential, version = generation, listId = operation.listId || api.getState().Wunschliste.activeList || 'default'
      let succeeded = false
      queue = queue.then(async () => {
        if (version !== generation) return
        let actionName = operation.action, extra = {}
        if (actionName === 'list' && localStorage.getItem('wunschliste')) {
          const guest = JSON.parse(localStorage.getItem('wunschliste') || '{}')
          actionName = 'merge'; extra = { items: Object.values(guest.items || {}), listId: 'default' }
        }
        const data = await wishlistRequest(actionName, { ...operation, token, listId, ...extra })
        if (version === generation && actionName === 'merge') localStorage.removeItem('wunschliste')
        if (version === generation) { apply(data.lists, operation.action === 'create' ? data.lists[data.lists.length - 1].id : undefined); succeeded = true }
      }).catch(error => { if (version === generation) api.dispatch({ type: 'wishlistAccountError', payload: error.message }) })
      return action.type === 'wishlistCommand' ? queue.then(() => succeeded) : action
    }
    return next(action)
  }
}
